import { importWhenVisible } from '@studiometa/js-toolkit';
import { Transition } from '@studiometa/ui';
import { untrapFocus, trapFocus } from '@studiometa/js-toolkit/utils';

/**
 * Cart component
 * @see https://liquid-ajax-cart.js.org/v2/
 */
export default class Cart extends Transition {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Cart',
    refs: ['close[]'],
    components: {
      CrossSell: (app) =>
        importWhenVisible(() => import('../../Sections/Slider/index.js'), 'CrossSell', app),
    },
  };

  isOpen = false;

  /**
   * mounted
   */
  mounted() {
    document.addEventListener('liquid-ajax-cart:request-end', (event) => {
      const { requestState } = event.detail;

      // If the "add to cart" request is successful
      if (requestState.requestType === 'add' && requestState.responseData?.ok) {
        this.open();
      }

      if (!requestState.responseData?.ok) {
        this.$root.Toaster.addToast(requestState.responseData?.body?.message);
      }

      this.$update();
    });
  }

  /**
   * Focus trap when Cart is open
   * @param {boolean} ESC Will be true if the key initiating the event is the esc key.
   */
  keyed({ event, isDown, isUp, ESC }) {
    if (!this.isOpen) {
      return;
    }

    if (isDown) {
      trapFocus(document.body, event);
    }

    if (ESC && isUp) {
      this.close();
    }
  }

  /**
   * onCloseClick
   */
  onCloseClick() {
    this.close();
  }

  /**
   * open fn
   */
  open() {
    document.addEventListener('keyup', (event) => {
      trapFocus(this.$el, event);
    });
    this.isOpen = true;
    this.enter();
    document.body.classList.add('overflow-hidden', 'fixed', 'w-full');
    this.$el.setAttribute('aria-hidden', 'false');
    this.$el.removeAttribute('inert');
  }

  /**
   * close fn
   */
  close() {
    untrapFocus();
    this.isOpen = false;
    this.leave();
    document.body.classList.remove('overflow-hidden', 'fixed', 'w-full');
    this.$el.setAttribute('aria-hidden', 'true');
    this.$el.setAttribute('inert', '');
  }
}
